import service from '@/services/facturacion/bitacora'

const getDefaultState = () => ({
  list: []
})

export const state = () => getDefaultState()

export const mutations = {
  SET_LIST: (state, response) => {
    state.list = response
  },
  RESET_LIST: state => {
    state.list = []
  }
}
export const actions = {
  readByIdFactura: async ({ commit }, idFactura) => {
    commit('RESET_LIST')

    return service.readByIdFactura(idFactura).then(response => {
      commit('SET_LIST', response)

      return response
    })
  }
}
